<script>
import {Radar} from 'vue-chartjs'


export default {
  extends: Radar,
  props: {
    radarChartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.renderChart(this.radarChartData, this.options)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/RaderChart.vue